export default __webpack_public_path__ + "static/media/multipay-logo.d38ad9c9.png";